import type { EnvironmentConfig } from "./EnvironmentConfig";


declare namespace window {
    
    let __TWILIO_FLEX_SDK__: { environmentConfig: EnvironmentConfig } | undefined;
}

export const getEnvironmentConfig = (): EnvironmentConfig => ({
    ...window.__TWILIO_FLEX_SDK__?.environmentConfig
});
